import { Injectable } from '@angular/core';

declare var Razorpay: any;

@Injectable()
export class RazorpayService {
  constructor() { }

  public initializePayment(orderId: string, amount: number, currency: string, name: string, description: string, prefill: any, callSuccessPaymentback: (response: any) => void, callFailedPaymentback: (response: any) => void, callPaymentPopUpClose: () => void): void {
    const options = {
      key: 'rzp_test_b1GsJINiEMAFXF', // Replace with your Razorpay key
      amount: amount * 100, // Amount in paisa (INR is multiplied by 100)
      currency: currency,
      name: name,
      description: description,
      order_id: orderId,
      handler: callSuccessPaymentback,
      prefill: prefill, // Prefill user data
      theme: {
        color: '#3399cc',
      },
      modal: {
        ondismiss: () => {
          console.log('Payment popup closed by user');
          callPaymentPopUpClose();
        }
      }
    };

    const rzp = new Razorpay(options);
    rzp.on('payment.failed', function (response) {
      callFailedPaymentback(response);
      rzp.close();
    });

    rzp.open();
  }
}



// WEBPACK FOOTER //
// ./src/app/prasad-order/razorpay.service.ts